import { UserRole } from '@repo/common/enums/UserRole';
import { useSuspenseFeatureAccess } from '../../api/hooks/workspace/useSuspenseFeatureAccess';
import { FeatureGuard } from '../../components/FeatureGuard/FeatureGuard';
import { PageLayoutOuterWrapper } from '../../components/PageLayout';
import type { AutomationPageProps } from './types';
import AutomationPageV2 from './V2/AutomationPageV2';
import { AutomationPageV2StoreProvider } from './V2/context';

function AutomationPageWrapper({ id: propsId }: AutomationPageProps) {
	const { automationsAccess } = useSuspenseFeatureAccess();

	return (
		<AutomationPageV2StoreProvider>
			<FeatureGuard
				featureName="Automations"
				description="Automatically set tags, owners, property values, and so much more with automations."
				v1AllowedRoles={[UserRole.ADMIN, UserRole.EDITOR]}
				v2Permission="Automations.Read"
				isFeatureIncludedInPlan={automationsAccess ?? false}
				isAlwaysIncludedFeature={false}
			>
				<PageLayoutOuterWrapper>
					<AutomationPageV2 id={propsId} />
				</PageLayoutOuterWrapper>
			</FeatureGuard>
		</AutomationPageV2StoreProvider>
	);
}

export default AutomationPageWrapper;
